import React, { useState } from 'react';
import Modal from './Modal';
import { AccentButton } from './Button';
import { FolderIcon } from '../icons';

export default function MoveModal({ isOpen, onClose, folders, currentFolderId, onConfirm }) {
  const [selectedFolderId, setSelectedFolderId] = useState(null);

  const handleConfirm = async () => {
    if (!selectedFolderId) return;
    await onConfirm(selectedFolderId);
    setSelectedFolderId(null);
    onClose();
  };

  const handleClose = () => {
    setSelectedFolderId(null);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="auto">
      <div className="w-full max-w-[400px] bg-[#FCFCFC] dark:bg-[#1A1A1A] border border-[#ECECEC] dark:border-[#202020] rounded-3xl flex flex-col overflow-hidden mx-auto">
        <div className="px-6 pt-6 pb-4">
          <h3 className="text-lg font-medium text-[#121212] dark:text-[#D0D0D0]">Move to folder</h3>
        </div>

        <div className="px-4 pb-4 flex flex-col gap-1 max-h-[300px] overflow-y-auto">
          {folders.map((folder) => {
            const isDisabled = folder.id === currentFolderId;
            const isActive = folder.id === selectedFolderId;
            return (
              <button
                key={folder.id}
                onClick={() => !isDisabled && setSelectedFolderId(folder.id)}
                disabled={isDisabled}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-xl transition-colors text-left ${
                  isDisabled
                    ? 'opacity-40 cursor-not-allowed'
                    : isActive
                    ? 'bg-[#F1F1F1] dark:bg-[#252525]'
                    : 'hover:bg-[#F1F1F1] dark:hover:bg-[#252525]'
                }`}
              >
                <FolderIcon size={16} color="rgba(74, 186, 98, 1)" fill="rgba(74, 186, 98, 0.2)" />
                <span className="text-sm font-medium text-[#121212] dark:text-[#D0D0D0]">{folder.name}</span>
                {isDisabled && (
                  <span className="ml-auto text-xs text-[#7B7B7B] dark:text-[#848484]">current</span>
                )}
              </button>
            );
          })}
        </div>

        <div className="flex items-center justify-end gap-3 px-6 py-4 border-t border-[#ECECEC] dark:border-[#202020]">
          <AccentButton variant="secondary" onClick={handleClose}>Cancel</AccentButton>
          <AccentButton variant="primary" onClick={handleConfirm} disabled={!selectedFolderId}>Move</AccentButton>
        </div>
      </div>
    </Modal>
  );
}
